/**
 * @desc directive that prevents user from inputting anything but numbers
 */

(function() {
	'use strict';

	angular
        .module('directives')
        .directive('numbersOnly', numbersOnly);

	function numbersOnly() {
		var directive = {
			link: link,
			scope: true,
			restrict: 'A'
		};
		return directive;

		function link(scope, element, attrs, ctrl) {
			element.on('keypress', function(event) {
				var value = event.key;
				return /^[0-9,.]*$/.test(value);
			});

			element.on('keyup', function(event) {
				if (event.target.value !== '' && isNaN(parseFloat(event.target.value))) {
					jQuery('#' + event.target.id).addClass('has-error');
				} else {
					jQuery('#' + event.target.id).removeClass('has-error');
				}
			});
		}
	}
})();
